import { constantes } from "../../add-documento-frete/resources/constantes";

export class FormatTransportadora {
  constructor(transportadora) {
    const estados = constantes.estados;
    if (!transportadora) {
      return false;
    }
    this.nomeRazaoSocial = transportadora.xNome;
    this.naturezaSocial = "juridica";
    this.cnpjCpf = transportadora.CNPJ || "";
    this.inscricaoEstadual = transportadora.IE || "";
    this.idTiposPessoa = [3];
    this.setInformacoesEstado(transportadora.enderEmit, estados);
  }

  setInformacoesEstado(transportadora, listaEstados) {
    if (listaEstados.length) {
      const estado = listaEstados.find(
        ({ sigla }) => sigla === transportadora.UF
      );
      this.endereco = {
        localEmbarque: estado?.sigla
          ? `${transportadora.xMun} - ${estado?.sigla}, ${transportadora.xLgr}/${transportadora.nro}`
          : "",
        ufEmbarque: estado?.id,
      };
    }
  }
}